import $ from "jquery";

const claimCompanion = {
  methods:{
    ajaxCall:function(el){
      el.find('.claims__companion-form').on('submit',function(evt){
      evt.preventDefault();
      const locationVal = el.find('#locationDropdown').val();
      const dataBody = JSON.stringify({"stateName":`${locationVal}`});
      const detailEl = el.find('.claims__companion__details .companion-detail-wrapper');
      const clusterHead = detailEl.eq(0).find('h4');
      const mobileHead = detailEl.eq(1).find('h4');
      const emailHead = detailEl.eq(2).find('h4');
      $.ajax({
        method:'POST',
        url:'/bin/chli/getClaimCompanion',
        dataType:'json',
        data:dataBody,
        contentType:"application/json"
      }).done((res,status)=>{
        el.find('.claims__companion__details').css('display','none');
        detailEl.eq(0).empty();
        detailEl.eq(0).append(clusterHead);
        detailEl.eq(1).empty();
        detailEl.eq(1).append(mobileHead);
        detailEl.eq(2).empty();
        detailEl.eq(2).append(emailHead);
          if(Array.isArray(res)){
            $.each(res,function(idx,obj){
              detailEl.eq(0).append(`<p class="text-white font-16 companion__name companion__details__value">${obj.clusterHead}</p>`);
              detailEl.eq(1).append(`<p class="text-white font-16 companion__contact companion__details__value">${obj.contactNumber}</p>`);
              detailEl.eq(2).append(`<p class="text-white font-16 companion__email companion__details__value">${obj.emailId}</p>`);
            });
          }
          else{
            detailEl.eq(0).append(`<p class="text-white font-16 companion__name companion__details__value">${res.clusterHead}</p>`);
            detailEl.eq(1).append(`<p class="text-white font-16 companion__contact companion__details__value">${res.contactNumber}</p>`);
            detailEl.eq(2).append(`<p class="text-white font-16 companion__email companion__details__value">${res.emailId}</p>`);
          }
          el.find('.claims__companion__details').css('display','block');
      }).fail((jqXhr,status)=>{
        console.log('error while fetching',status,jqXhr);
      });
      });
    },

     getClaimCompanionTitle : function (containerElement) {
        let container = containerElement.closest('.claims__companion__section');
        let titleElement = container.find('.section_container--secondary h2');
        var title = null;
        if (titleElement.length > 0) {
         title = titleElement.text().trim();
        }
        return title;
     },

      buttonClickHandler : function() {
        $('.claims__companion__section').on('click', '.claims__companion__search__btn', function() {
          let buttonText = $(this).text().replace(/\s+/g, ' ').trim();
          let title = claimCompanion.methods.getClaimCompanionTitle($(this));
          var obj = claimCompanion.methods.claimCompanionDataLayerObj(buttonText,title);
          createDataLayer('buttonClick', obj);
        });
      },

      SelectClaimCompanionDropdownItemClickHandler: function () {
        $('.claims__companion__location__selected').on('change', function () {
          let title = claimCompanion.methods.getClaimCompanionTitle($(this));
          let value = $(this).val();
          var obj = claimCompanion.methods.claimCompanionDataLayerObj(value,title);
           createDataLayer('Select_dropdown_item', obj);
        });
      },

                claimCompanionDataLayerObj: function (el,e) {
                      var obj = {
                        'articleName': "",
                        'blogCategory': "",
                        'blogPageCategory': "",
                        'buttonText': el ? el : "",
                        'pageSection': e ? e : "Claim Companion",
                        'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                        'planOption': "",
                        'productCategory': "",
                        'productName': "",
                        'question': "",
                        'source': "",
                        'leadForm': "",
                        'searchTerm': "",
                        'videoTitle': "",
                        'bannerName': "",
                      };
                      return obj;
                    },

    init:function(){
      const ajxCall = this.ajaxCall.bind(claimCompanion);
      $('.claims__companion__section').each((idx,el)=>{
        ajxCall($(el).eq(0));
      });
    }
  }
};

$(()=>{
  claimCompanion.methods.init();
});
$(document).ready(function () {
  claimCompanion.methods.SelectClaimCompanionDropdownItemClickHandler();
  claimCompanion.methods.buttonClickHandler();
});

